import Image from "next/image";

const GAUGE_TRACK = "/assets-next/tools/previews/svg/discount-gauge-track.svg";
const GAUGE_FILL = "/assets-next/tools/previews/svg/discount-gauge-fill.svg";
const GAUGE_POINTER =
  "/assets-next/tools/previews/svg/discount-gauge-pointer.svg";

/** White dots on the filled arc — card-relative coords mapped to preview frame (Figma 11043:70414). */
const SPECKLES = [
  { left: 124, top: 62.3 },
  { left: 136, top: 65.3 },
  { left: 127, top: 73.3 },
  { left: 95, top: 71.3 },
  { left: 106, top: 82.3 },
  { left: 104, top: 63.3 },
  { left: 115, top: 70.3 },
  { left: 123, top: 86.3 },
  { left: 94, top: 58.3 },
  { left: 80, top: 75.3 },
  { left: 79, top: 86.3 },
] as const;

/**
 * Discount break-even card inset (Figma 11060:39442 + sibling gauge layers on 11043:70414).
 * Gauge rings/pointer are SVG-only; labels and badge text are HTML.
 */
export function DiscountBreakEvenPreview() {
  return (
    <div
      data-testid="discount-break-even-canvas"
      className="relative h-full w-full overflow-hidden"
    >
      <p className="text-grey-950 absolute top-[15px] left-[19px] text-[12px] leading-[1.4] whitespace-nowrap">
        Units to hold gross profit
      </p>

      <Image
        src={GAUGE_TRACK}
        alt=""
        width={181}
        height={181}
        aria-hidden
        className="pointer-events-none absolute top-[42px] left-[15px] h-[181px] w-[181px] max-w-none"
      />
      <Image
        src={GAUGE_FILL}
        alt=""
        width={170}
        height={170}
        aria-hidden
        className="pointer-events-none absolute top-[48px] left-[21px] h-[170px] w-[170px] max-w-none"
      />

      {SPECKLES.map((dot) => (
        <span
          key={`${dot.left}-${dot.top}`}
          aria-hidden
          className="bg-grey-0 pointer-events-none absolute size-[2px] rounded-full"
          style={{ left: dot.left, top: dot.top }}
        />
      ))}

      <div
        aria-hidden
        className="pointer-events-none absolute top-[105px] left-[131px] h-[48px] w-[29px]"
      >
        <Image
          src={GAUGE_POINTER}
          alt=""
          width={29}
          height={48}
          className="block size-full max-w-none"
        />
      </div>

      <div
        aria-hidden
        className="absolute top-[69px] left-[166px] flex h-6 w-[43px] items-center justify-center rounded-xl bg-[#3fa95b]"
      >
        <span className="text-[8px] leading-none font-medium text-white">
          72%
        </span>
      </div>
    </div>
  );
}
